<template>
  <div class="container grid-lg mb-2 p-0" aria-labelledby="header-title">
    <Header title="Import"></Header>

    <div class="container grid-sm">
      <form class="form-horizontal">
        <div class="form-group">
          <div class="col-3 col-sm-12">
            <label class="form-label" for="format">Format</label>
          </div>
          <div class="col-9 col-sm-12">
            <select v-model="format" id="format" class="form-select select-lg">
              <option value="builtin">Built-in</option>
              <option value="matpower">MATPOWER</option>
              <option value="raw">RAW</option>
              <option value="json">JSON</option>
            </select>
          </div>
        </div>
        <div v-if="format === 'builtin'" class="form-group">
          <div class="col-3 col-sm-12">
            <label class="form-label" for="casename">Case</label>
          </div>
          <div class="col-9 col-sm-12">
            <select
              ref="casename"
              v-model="casename"
              id="casename"
              class="form-select select-lg"
            >
              <option value="empty">Empty</option>
              <option value="case4_dist">Radial Distribution System</option>
              <option value="case4gs">Grainger &amp; Stevenson, 1994</option>
              <option value="case5">Li &amp; Bo PJM, 2010</option>
              <option value="case6ww">Wood &amp; Wollenberg, 1996</option>
              <option value="case9">Schulz, Turner &amp; Ewart, 1974</option>
              <option value="case14">IEEE 14, 1962</option>
              <option value="case18">Grady, Samotyj &amp; Noyola, 1992</option>
              <option value="case22">
                Ramalinga Raju, Ramachandra Murthy &amp; Ravindra, 2012
              </option>
              <option value="case24_ieee_rts">
                Reliability Test System, 1979
              </option>
              <option value="case30">Alsac &amp; Stott, 1974</option>
              <option value="case33">Baran &amp; Wu, 1989</option>
              <option value="case39">Bills et al. 1970 (New England)</option>
              <option value="case57">IEEE 57, 1961</option>
              <option value="case69">Das, 2008</option>
              <option value="case85">Das, Kothari &amp; Kalam, 1995</option>
              <option value="case89pegase">
                Josz, Fliscounakis, Maeght &amp; Panciatici, 2016
              </option>
              <option value="case118">IEEE 118, 1961</option>
              <option value="case141">
                Khodr, Olsina, De Oliveira-De Jesus &amp; Yusta, 2008
              </option>
              <option value="case145">IEEE 145, 1990</option>
              <option value="case300">IEEE 300, 1991</option>
              <option value="case_ACTIVSg200">
                Birchfield, Xu, Gegner, Shetye &amp; Overbye, 2017
              </option>
              <option value="case_ACTIVSg500">
                Birchfield, Xu, Gegner, Shetye &amp; Overbye, 2017
              </option>
              <option value="case_ieee30">IEEE 30, 1961</option>
              <option value="case_RTS_GMLC">
                Reliability Test System (GMLC), 2019
              </option>
            </select>
            <span v-if="buses[casename]" class="form-input-hint">
              No. of buses = {{ buses[casename] }}
            </span>
          </div>
        </div>
        <div v-if="format !== 'builtin'" class="form-group">
          <div class="col-3 col-sm-12">
            <label class="form-label" for="casefile">Input File</label>
          </div>
          <div class="col-9 col-sm-12">
            <input
              ref="casefile"
              v-bind:accept="accept"
              @change="processFile($event)"
              type="file"
              id="casefile"
              class="form-input"
            />
          </div>
        </div>
        <div v-if="format === 'raw'" class="form-group">
          <div class="col-3 col-sm-12">
            <label class="form-label" for="rev">Revision</label>
          </div>
          <div class="col-9 col-sm-12">
            <input v-model="rev" id="rev" class="form-input" />
          </div>
        </div>
        <div class="form-group">
          <div class="col-3 col-sm-12"></div>
          <div class="col-9 col-sm-12">
            <div>
              <button
                v-on:click="importCase"
                v-bind:class="{ disabled: !importEnabled }"
                type="button"
                class="btn btn-primary"
              >
                <upload-icon size="1x" class="icon" />
                Import
              </button>
            </div>
            <span class="form-input-hint">
              Existing data will be overwritten.
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { UploadIcon } from "vue-feather-icons";

import Header from "../components/Header";

import ConfigStore from "../stores/ConfigStore";
import Module from "../module";

import MPCStore from "../stores/MPCStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";
import IOStore from "../stores/IOStore";

export default {
  name: "Import",
  components: {
    Header,
    UploadIcon
  },
  mounted() {
    this.$refs["casename"].focus();
  },
  data() {
    return {
      Module: Module.data,
      format: "builtin",
      casename: "case9",
      buses: {
        case4_dist: 4,
        case4gs: 4,
        case5: 5,
        case6ww: 6,
        case9: 9,
        case14: 14,
        case18: 18,
        case22: 22,
        case24_ieee_rts: 24,
        case30: 30,
        case33: 33,
        case39: 39,
        case57: 57,
        case69: 69,
        case85: 85,
        case89pegase: 89,
        case118: 118,
        case141: 141,
        case145: 145,
        case300: 300,
        case_ACTIVSg200: 200,
        case_ACTIVSg500: 500,
        case_ieee30: 30,
        case_RTS_GMLC: 72
      },
      rev: "",
      files: 0
    };
  },
  computed: {
    importEnabled() {
      if (this.format === "builtin") {
        return this.Module.ready;
      } else {
        return this.Module.ready && this.files;
      }
    },
    accept() {
      if (this.format === "json") {
        return "application/json";
      } else if (this.format === "matpower") {
        return "text/x-matlab";
      }
      return "";
    }
  },
  methods: {
    clearCase() {
      IOStore.methods.error("");
      IOStore.methods.output("");
      PFStore.methods.setPF({});
      PFStore.methods.setOutput("");
      OPFStore.methods.setOPF({});
      OPFStore.methods.setOutput("");
      MPCStore.methods.setMPC({});
      ConfigStore.methods.deletePositions();
      ConfigStore.methods.deleteTransform();
    },
    importCase() {
      let importComponent = this;
      let router = this.$router;
      if (this.format === "builtin") {
        if (this.casename === "empty") {
          this.clearCase();
          router.push("/");
        } else {
          this.clearCase();
          Module.methods
            .loadCase(this.casename)
            .catch(err => {
              IOStore.methods.error(err.message);
              IOStore.methods.output(err.output);
            })
            .then(function(resp) {
              if (resp) {
                MPCStore.methods.setMPC(resp.retval);
                router.push("/");
              }
            });
        }
      } else if (this.format === "matpower") {
        let input = this.$refs["casefile"];

        let reader = new FileReader();
        reader.onload = function() {
          importComponent.clearCase();
          let text = reader.result;
          Module.methods
            .loadCaseData(text)
            .catch(err => {
              IOStore.methods.error(err.message);
              IOStore.methods.output(err.output);
            })
            .then(function(resp) {
              if (resp) {
                MPCStore.methods.setMPC(resp.retval);
                router.push("/");
              }
            });
        };
        reader.readAsText(input.files[0]);
      } else if (this.format === "raw") {
        let input = this.$refs["casefile"];

        let reader = new FileReader();
        reader.onload = function() {
          importComponent.clearCase();
          let text = reader.result;
          Module.methods
            .readRaw(text, this.rev)
            .catch(err => {
              IOStore.methods.error(err.message);
              IOStore.methods.output(err.output);
            })
            .then(function(resp) {
              if (resp) {
                MPCStore.methods.setMPC(resp.retval);
                router.push("/");
              }
            });
        };
        reader.readAsText(input.files[0]);
      } else if (this.format === "json") {
        let input = this.$refs["casefile"];

        let reader = new FileReader();
        reader.onload = function() {
          let text = reader.result;
          if (text) {
            importComponent.clearCase();
            let mpc = JSON.parse(text);
            MPCStore.methods.setMPC(mpc);
            router.push("/");
          }
        };
        reader.readAsText(input.files[0]);
      }
    },
    processFile(event) {
      this.files = event.target.files.length;
    }
  }
};
</script>

<style scoped></style>
